import { render } from "./FilePrime.vue?vue&type=template&id=7cac628d"
import script from "./FilePrime.vue?vue&type=script&lang=js"
export * from "./FilePrime.vue?vue&type=script&lang=js"

import "./FilePrime.vue?vue&type=style&index=0&id=7cac628d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__